import { Component, OnInit } from "@angular/core";
import {
  EmmiterService,
  ResumenEmmiterData,
} from "../../../../../services/emmiter/emmiter.service";
import { CurrencyPipe } from "@angular/common";
import { SafeHtml } from "@angular/platform-browser";
import { MensajesService } from "../../../../../services/mensajes/mensajes.service";
import { IdentificadorMensajesEnum } from "../../../../../enum/mensajes.enum";

@Component({
  selector: "app-resumen",
  templateUrl: "./resumen.component.html",
  styleUrl: "./resumen.component.css",
  providers: [CurrencyPipe],
})
export class ResumenComponent implements OnInit {
  conceptoData: any = [];

  seguroCoberturaData: any[] = [];

  parcialidadesData: any[] = [];

  total: string | null = "$0.00";
  checked: boolean = false;
  parcialidades: string = "Parcialidades";
  textoSeguroParcialidades: SafeHtml = "";
  textoSeguroNotificacion: SafeHtml = "";
  conceptoOrderList: string[] = ["total", "beca", "prestamo", "subtotal"];
  becaOrderList: string[] = [
    "cobertura",
    "sgmm",
    "subtotalSegurosCobertura",
    "pagoFijo",
  ];
  tooltipResetText: SafeHtml = "";
  resumenEmmiterData: ResumenEmmiterData;
  textoSeguroAportacion: SafeHtml = "";

  constructor(
    private emmiter: EmmiterService,
    private currencyPipe: CurrencyPipe,
    private mensajesService: MensajesService
  ) {}

  ngOnInit(): void {
    this.getResumenEmmiter();
    this.getBorrarFormulario();
    this.getMensajes();
  }

  getBorrarFormulario() {
    this.emmiter.borrarFormulario.subscribe(() => this.borrarTablas());
  }

  getMensajes() {
    this.mensajesService.labelTextEmmiter.subscribe((response: boolean) => {
      if (response) {
        this.textoSeguroParcialidades =
          this.mensajesService.getMensajeByEtiquetaBypassSecurityTrustHtml(
            IdentificadorMensajesEnum.parcialidades
          );
        this.textoSeguroNotificacion =
          this.mensajesService.getMensajeByEtiquetaBypassSecurityTrustHtml(
            IdentificadorMensajesEnum.notificación
          );
        this.textoSeguroAportacion =
          this.mensajesService.getMensajeByEtiquetaBypassSecurityTrustHtml(
            IdentificadorMensajesEnum.aportación
          );

        this.tooltipResetText =
          this.mensajesService.getTooltipByEtiquetaBypassSecurityTrustHtml(
            "reset"
          );
      }
    });
  }

  getResumenEmmiter() {
    this.emmiter.resumenEmmiter.subscribe(
      (resumenEmmiterData: ResumenEmmiterData) => {
        this.resumenEmmiterData = resumenEmmiterData;
        this.asignarConcepto(resumenEmmiterData);
        this.asignarPacialiades(resumenEmmiterData);        
      }
    );
  }

  asignarConcepto(resumenEmmiterData: ResumenEmmiterData) {
    this.total = this.convertCurrency(
      Number(resumenEmmiterData.calcular.contado?.monto)
    );

    this.conceptoData = [];

    const concepto: any = resumenEmmiterData.calcular;

    if (this.resumenEmmiterData?.nivel?.clave == "03")
      this.conceptoOrderList = ["total", "beca", "subtotal"];
    else this.conceptoOrderList = ["total", "beca", "prestamo", "subtotal"];

    this.asignarSeguro(resumenEmmiterData);

    this.conceptoOrderList.forEach((variable: string) => {
      this.conceptoData.push(this.contentResumen(concepto, variable));
    });
  }

  convertCurrency(currency: number): string | null {
    return this.currencyPipe.transform(currency, "$", "symbol", "1.2-2");
  }

  asignarSeguro(resumenEmmiterData: ResumenEmmiterData) {
    this.seguroCoberturaData = [];

    const concepto: any = resumenEmmiterData.calcular;

    this.becaOrderList.forEach((variable: string) => {
      this.seguroCoberturaData.push(this.contentResumen(concepto, variable));
    });
  }

  contentResumen(concepto: any, variable: string): any {
    if (!concepto[variable]) return undefined;

    const _class = this.getClass(variable);
    const leyenda = concepto[variable].leyenda;

    if (
      leyenda === "" ||
      !leyenda ||
      (this.resumenEmmiterData?.nivel?.clave == "03" && variable == "pagoFijo")
    )
      return undefined;

    return {
      concepto: leyenda,
      importe: this.convertCurrency(concepto[variable].monto),
      class: _class,
      etiqueta: concepto[variable].tooltip,
    };
  }

  getClass(variable: string): string {
    const isSubtotal =
      variable == "subtotalSegurosCobertura" || variable == "subtotal";
    const _class = isSubtotal ? "fw-bold border-total" : "";
    const marginTop = variable == "pagoFijo" ? "fw-bold pt-5" : "";

    return `${_class} ${marginTop}`;
  }

  asignarPacialiades(resumenEmmiterData: ResumenEmmiterData) {
    const { parcialidades } = resumenEmmiterData.calcular;
    this.parcialidades = `${parcialidades.disponibles} parcialidades`;

    this.parcialidadesData = [
      {
        parcialidad: "Primera parcialidad*",
        importe: `${this.convertCurrency(parcialidades.inicial)}`,
      },
      {
        parcialidad: `${parcialidades.leyenda}`,
        etiqueta: parcialidades.tooltip,
        importe: `${this.convertCurrency(parcialidades.general)} c/u`,
      },
    ];
  }

  reiniciar() {
    this.borrarTablas();
    this.emmiter.reiniciarEmmiter.emit();
  }

  borrarTablas() {
    this.conceptoData = [];
    this.seguroCoberturaData = [];
    this.parcialidadesData = [];
    this.parcialidades = "Parcialidades";
    this.total = "$0.00";
  }
}
